import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { chuyenNganhReducer } from "./category/chuyenNganhReducer";
import { keHoachNamReducer } from "./category/keHoachNamReducer";
import { lopNamHocReduer } from "./category/lopNamHocReduer";

import { baoCaoReducer } from "./bao-cao/baoCaoReducer";
import { bienLaiPagingReducer } from "./bien-lai/bienLaiPagingReducer";
import { bienLaiViewChiTietReducer } from "./bien-lai/bienLaiViewChiTietReducer";
import { bienLaiViewReducer } from "./bien-lai/bienLaiViewReducer";
import { bienLaiViewTheoLopChiTietReducer } from "./bien-lai/bienLaiViewTheoLopChiTietReducer";
import { bienLaiViewTheoLopReducer } from "./bien-lai/bienLaiViewTheoLopReducer";
import { bienLaiViewTuyenSinhReducer } from "./bien-lai/bienLaiViewTuyenSinhReducer";
import { bieuDoReducer } from "./bieu-do/bieuDoReducer";
import { thongKeCanXuLyReducer } from "./dashboard/thongKeCanXuLyReducer";
import { bienLaiThietLapReducer } from "./category/bienLaiThietLapReducer";
import { chuongTrinhDaoTaoKienThucReducer } from "./category/chuongTrinhDaoTaoKienThucReducer";
import { configInvoiceReducer } from "./category/configInvoiceReducer";
import { coSoReducer } from "./category/coSoReducer";
import { danhBaSinhVienReducer } from "./category/danhBaSinhVienReducer";
import { dotTuyenSinhReducer } from "./category/dotTuyenSinhReducer";
import { heReducer } from "./category/heReducer";
import { hinhThucNopTienReducer } from "./category/hinhThucNopTienReducer";
import { hocKyDangKyReducer } from "./category/hocKyDangKyReducer";
import { khoaReducer } from "./category/khoaReducer";
import { khoiNganhReducer } from "./category/khoiNganhReducer";
import { loaiThuChiReducer } from "./category/loaiThuChiReducer";
import { loaiThuNhapHocReducer } from "./category/loaiThuNhapHocReducer";
import { loaiThuTuyenSinhReducer } from "./category/loaiThuTuyenSinhReducer";
import { lePhiBuocNhayReducer } from "./category/lePhiBuocNhayReducer";
import { mucHocPhiTinChiReducer } from "./category/mucHocPhiTinChiReducer";
import { mucHocPhiTheoMonReducer } from "./category/mucHocPhiTheoMonReducer";
import { mucHocPhiTheoCTDTReducer } from "./category/mucHocPhiTheoCTDTReducer";
import { nganhReducer } from "./category/nganhReducer";
import { nhomLoaiThuChiReducer } from "./category/nhomLoaiThuChiReducer";
import { quocTichReducer } from "./category/quocTichReducer";
import { trangThaiHocReducer } from "./category/trangThaiHocReducer";
import { tsNganhXetTuyenReducer } from "./category/tsNganhXetTuyenReducer";
import { voucherReducer } from "./category/voucherReducer";
import { layoutReducer } from "./common/layoutReducer";
import { dichVuHoSoReducer } from "./dich-vu/dichVuHoSoReducer";
import { dichVuThanhToanReducer } from "./dich-vu/dichVuThanhToanReducer";
import { dichVuThongTinReducer } from "./dich-vu/dichVuThongTinReducer";
import { dongBoCongNoReducer } from "./dong-bo/dongBoCongNoReducer";
import { dongBoHocPhiReducer } from "./dong-bo/dongBoHocPhiReducer";
import { dongBoPhiKyTucXaReducer } from "./dong-bo/dongBoPhiKyTucXaReducer";
import { gachNoThuCongReducer } from "./dong-bo/gachNoThuCongReducer";
import { hoaDonDienTuReducer } from "./hoa-don/hoaDonDienTuReducer";
import { kyHieuHoaDonReducer } from "./hoa-don/kyHieuHoaDonReducer";
import { hoaDonDieuChinhThuCongReducer } from "./hoa-don/hoaDonDieuChinhThuCongReducer";
import { danhSachLopTinChiReducer } from "./lop-tin-chi/danhSachLopTinReducer";
import { planLopTinChiReducer } from "./lop-tin-chi/planLopTinChiReducer";
import { danhSachMienGiamReducer } from "./mien-giam/danhSachMienGiamReducer";
import { danhSachTroCapReducer } from "./tro-cap/danhSachTroCapReducer";
import { hinhThucChiTietReducer } from "./mien-giam/hinhThucChiTietReducer";
import { hinhThucReducer } from "./mien-giam/hinhThucReducer";
import { hinhThucTinhReducer } from "./mien-giam/hinhThucTinhReducer";
import { mucThuReducer } from "./mucThu/mucThuReducer";
import { mucThuTamThuReducer } from "./mucThu/mucThuTamThuReducer";
import { mucThuTinChiReducer } from "./mucThu/mucThuTinChiReducer";
import { nganHangReducer } from "./ngan-hang/nganHangReducer";
import { nofiticationReducer } from "./nofitication/nofiticationReducer";
import { reportNhapHocReducer } from "./report/reportNhapHocReducer";
import { reportTuyenSinhReducer } from "./report/reportTuyenSinhReducer";
import { reportReducer } from "./report/reportReducer";
import { reportTamThuReducer } from "./report/reportTamThuReducer";
import { tongHopSinhVienReducer } from "./report/tongHopSinhVienReducer";
import { heSoLopTuNguyenReducer } from "./thiet-lap/heSoLopTuNguyenReducer";
import { thuPhiNhapHocReducer } from "./thu-phi-nhap-hoc/thuPhiNhapHocReducer";
import { thuPhiTamThuReducer } from "./thu-phi-tam-thu/thuPhiTamThuReducer";
import { importTuyenSinhReducer } from "./thu-phi-tuyen-sinh/importTuyenSinhReducer";
import { thuPhiTuyenSinhReducer } from "./thu-phi-tuyen-sinh/thuPhiTuyenSinhReducer";
import { thuPhiReducer } from "./thu-phi/thuPhiReducer";
import { thuPhiTheoLopReducer } from "./thu-phi/thuPhiTheoLopReducer";
import { monKhongTinhHocPhiReducer } from "./category/monKhongTinhHocPhiReducer";
import { doiTuongKhongTinhHocPhiReducer } from "./category/doiTuongKhongTinhHocPhiReducer";
import { monHocReducer } from "./category/monHocReducer";
import { quyDoiTyGiaReducer } from "./category/quyDoiTytgiaReducer";
import { loaiThuBoSungKienThucReducer } from "./category/loaiThuBoSungKienThucReducer";
import { bsktDotHocReducer } from "./category/bsktDotHocReducer";
import { dashboardSinhVienReducer } from "./dashboard-sinh-vien/dashboardSinhVienReducer";
import { mauPhieuThuCauHinhReducer } from "./category/mauPhieuThuCauHinhReducer";

const reducers = combineReducers({
  auth: authReducer,
  common: combineReducers({
    layout: layoutReducer,
  }),
  category: combineReducers({
    loaiThuChi: loaiThuChiReducer,
    mucHocPhiTinChi: mucHocPhiTinChiReducer,
    mucHocPhiTheoMon: mucHocPhiTheoMonReducer,
    mucHocPhiTheoCTDT: mucHocPhiTheoCTDTReducer,
    nganh: nganhReducer,
    chuyenNganh: chuyenNganhReducer,
    keHoachNam: keHoachNamReducer,
    he: heReducer,
    lopNamHoc: lopNamHocReduer,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucReducer,
    nhomLoaiThuChi: nhomLoaiThuChiReducer,
    hinhThucNopTien: hinhThucNopTienReducer,
    hocKyDangKy: hocKyDangKyReducer,
    khoa: khoaReducer,
    bienLaiThietLap: bienLaiThietLapReducer,
    dotTuyenSinh: dotTuyenSinhReducer,
    loaiThuNhapHoc: loaiThuNhapHocReducer,
    loaiThuBoSungKienThuc: loaiThuBoSungKienThucReducer,
    loaiThuTuyenSinh: loaiThuTuyenSinhReducer,
    lePhiBuocNhay: lePhiBuocNhayReducer,
    coSo: coSoReducer,
    khoiNganh: khoiNganhReducer,
    voucher: voucherReducer,
    configInvoice: configInvoiceReducer,
    trangThaiHoc: trangThaiHocReducer,
    tsNganhXetTuyen: tsNganhXetTuyenReducer,
    quocTich: quocTichReducer,
    danhBaSinhVien: danhBaSinhVienReducer,
    monKhongTinhHocPhi: monKhongTinhHocPhiReducer,
    doiTuongKhongTinhHocPhi: doiTuongKhongTinhHocPhiReducer,
    monHoc: monHocReducer,
    quyDoiTyGia: quyDoiTyGiaReducer,
    bsktDotHoc: bsktDotHocReducer,
    mauPhieuThuCauHinh: mauPhieuThuCauHinhReducer,
  }),
  nganHang: combineReducers({
    nganHang: nganHangReducer,
  }),
  mucThu: combineReducers({
    mucThu: mucThuReducer,
    mucThuTinChi: mucThuTinChiReducer,
    mucThuTamThu: mucThuTamThuReducer,
  }),
  mienGiam: combineReducers({
    hinhThuc: hinhThucReducer,
    hinhThucChiTiet: hinhThucChiTietReducer,
    hinhThucTinh: hinhThucTinhReducer,
    danhSachMienGiam: danhSachMienGiamReducer,
  }),
  troCap: combineReducers({
    danhSachTroCap: danhSachTroCapReducer,
  }),
  thuPhi: combineReducers({
    thuPhi: thuPhiReducer,
    thuPhiTheoLop: thuPhiTheoLopReducer,
    thuPhiNhapHoc: thuPhiNhapHocReducer,
    thuPhiTuyenSinh: thuPhiTuyenSinhReducer,
    importTuyenSinh: importTuyenSinhReducer,
    thuPhiTamThu: thuPhiTamThuReducer,
  }),
  bienLai: combineReducers({
    bienLaiView: bienLaiViewReducer,
    bienLaiViewTuyenSinh: bienLaiViewTuyenSinhReducer,
    bienLaiViewTheoLop: bienLaiViewTheoLopReducer,
    bienLaiViewChiTiet: bienLaiViewChiTietReducer,
    bienLaiViewTheoLopChiTiet: bienLaiViewTheoLopChiTietReducer,
    bienLaiPaging: bienLaiPagingReducer,
  }),
  hoaDon: combineReducers({
    hoaDonDienTu: hoaDonDienTuReducer,
    kyHieuHoaDon: kyHieuHoaDonReducer,
    hoaDonDieuChinhThuCong: hoaDonDieuChinhThuCongReducer,
  }),
  report: combineReducers({
    report: reportReducer,
    reportNhapHoc: reportNhapHocReducer,
    reportTuyenSinh: reportTuyenSinhReducer,
    reportTamThu: reportTamThuReducer,
    sinhVien: tongHopSinhVienReducer,
  }),
  lopTinChi: combineReducers({
    planLopTinChi: planLopTinChiReducer,
    danhSachLopTinChi: danhSachLopTinChiReducer,
  }),
  baoCao: combineReducers({
    baoCao: baoCaoReducer,
  }),
  bieuDo: combineReducers({
    bieuDo: bieuDoReducer,
  }),
  dashboard: combineReducers({
    thongKeCanXuLy: thongKeCanXuLyReducer,
  }),
  dongBo: combineReducers({
    hocPhi: dongBoHocPhiReducer,
    kyTucXa: dongBoPhiKyTucXaReducer,
    congNo: dongBoCongNoReducer,
    gachNoThuCong: gachNoThuCongReducer,
  }),
  thietLap: combineReducers({
    heSoLopTuNguyen: heSoLopTuNguyenReducer,
  }),
  dichVu: combineReducers({
    hoSo: dichVuHoSoReducer,
    thanhToan: dichVuThanhToanReducer,
    thongTin: dichVuThongTinReducer,
  }),
  nofitication: combineReducers({
    nofitication: nofiticationReducer,
  }),
  dashboardSinhVien: dashboardSinhVienReducer,
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
